const BASE_URL = process.env.REACT_APP_API;
export const ebayUsaUrl = `/department/ebay-usa`;
export const productPageUrl = `/shop/product/`;
export const ebayUsaBrands = `/department/ebay-usa/brand/`;
